/* eslint-disable no-param-reassign */
import * as types from '@/store/types';

export default {
  [types.SAVE_ANSWERS](state, answers) {
    let flag = 0;
    state.answers.filter(function(answer) {
      if (answers.id === answer.id) {
        answer.value = answers.value;
        flag = 1;
      }
    });
    if (flag === 0) {
      state.answers.push(answers);
    }
  },
  [types.SAVE_ANSWERS_FORM](state, answers) {
    state.answers.form[answers.type] = answers.field;
  }
};
